export default class CreateCustomAreaData {
    constructor(companyId, areaPoints, name) {
        this.companyId = companyId
        this.areaPoints = areaPoints
        this.name = name
    }
}